export const ConfiguratorConstants = {
    RadioButtonInputModule: "RadioButtonInputModule",       
    TextInputModule: "TextInputModule",
    ProductListModule: "ProductListModule",
    WallSectionModule: "WallSectionModule",
    WallSectionModuleWithRoundedCorners: "WallSectionModuleWithRoundedCorners",
    TextInputModuleSectionsProperty: "TextInputModuleSections",
    WallSectionRoundedProperty: "WallSectionRounded",
    WallSectionNonRoundedProperty: "WallSectionNonRounded",
    WallTypeProperty: "WallType",   
    MaxHeight: "MaxHeight",
    WallConfiguratorCookie: "WallConfiguratorCookie",    
} 